import React from 'react';

import MainForm from './MainForm';
import SecondaryForm from './SecondaryForm';

const LeftSection = ({
  result,
  calculated,
  setCalculated,
  setResult,
  setConsultation,
  setChecked,
  spare,
  resetApp,
}) => (
  <div className="left-section">
    { calculated
      ? <SecondaryForm result={result} setChecked={setChecked} spare={spare} resetApp={resetApp} />
      : <MainForm setCalculated={setCalculated} setResult={setResult} setConsultation={setConsultation} />
    }
  </div>
);

export default LeftSection;
